<template>
  <div class="flex items-center gap-2">
    <div
      v-if="showIcon"
      class="bg-background-positive-invisible rounded-xl p-2"
    >
      <FlagIcon />
    </div>
    <div class="font-medium">
      <p v-if="title" :class="titleClass">{{ title }}:</p>
      <p :class="textClass">
        {{ directionsText }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import type { specialOffers } from 'shared';

  import FlagIcon from '@/assets/images/green-flag-icon.svg?component';

  const props = withDefaults(
    defineProps<{
      special: specialOffers.Special;
      title?: string;
      titleClass?: string;
      textClass?: string;
      showIcon?: boolean;
    }>(),
    {
      title: '',
      titleClass: 'text-text-neutral-quaternary text-xs',
      textClass: 'text-text-neutral-primary text-sm',
      showIcon: true,
    },
  );

  const { t } = useI18n();

  const directionsText = computed(() => {
    const type = props.special.directions?.type;
    const routes = props.special.directions?.routes;

    switch (type) {
      case 'TO_CITIES':
      case 'TO_COUNTRIES':
        return routes.map(r => r?.name).join(', ');

      case 'CITIES_TO_CITIES':
      case 'COUNTRIES_TO_COUNTRIES':
        return routes
          .map(r => `${r?.origin?.name} - ${r?.destination?.name}`)
          .join(', ');

      case 'ALL':
        return t('specialOffer.details.allDirections', {
          airline: props.special.airline.name,
        });

      default:
        return '';
    }
  });
</script>
